export default {
  title: 'Onboarding-Link erstellen',
  steps: {
    select_gateway: 'Gateway auswählen',
    copy_link: 'Link kopieren',
  },
  select_gateway: {
    description: 'Wählen Sie das Zahlungsgateway aus, für das Sie einen dauerhaften Onboarding-Link erstellen möchten.',
  },
  link: {
    proxy_url_label: 'Onboarding-URL',
    expires_label: 'Gültig bis',
    copy_button: 'URL kopieren',
    copied: 'Kopiert!',
    description:
      'Teilen Sie diese URL mit dem Händler. Sie leitet zur Onboarding-Seite des Gateways weiter und ist bis zum Ablaufdatum gültig.',
  },
  buttons: {
    next: 'Weiter',
    back: 'Zurück',
    done: 'Fertig',
  },
  toasts: {
    create_success: 'Onboarding-Link erfolgreich erstellt.',
    create_failed: 'Onboarding-Link konnte nicht erstellt werden.',
  },
};
